import { render, staticRenderFns } from "./RelatedInvoices.vue?vue&type=template&id=23ef18f2"
import script from "./RelatedInvoices.vue?vue&type=script&lang=js"
export * from "./RelatedInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports